import {useEffect} from "react";
import {matchPath, Navigate, Route, Routes, useLocation} from "react-router";
import {ensureReauthSecret} from "../../features/auth/client-auth";
import type {UserRepo} from "../../models/UserRepo";
import Hub from "../Hub";
import GroupRoutes from "../lists/GroupRoutes";
import NotFound from "../NotFound";
import Profile from "../profile/Profile";
import AcceptGroupInvite from "./AcceptGroupInvite";

const AuthRoutes = ({userRepo}: {userRepo: UserRepo}) => {
  const {id, isSyncing} = userRepo.vals.useValues();
  const location = useLocation();
  useEffect(() => {
    if (id && isSyncing) void ensureReauthSecret(userRepo);
  }, [id, isSyncing, userRepo]);
  const getNextState = () => {
    if (matchPath("/add-group/:secret", location.pathname)) return {next: location.pathname};
  };
  if (!id) {
    return <Navigate to="/welcome" state={getNextState()} />;
  } else {
    return (
      <Routes>
        <Route path="/" element={<Hub userRepo={userRepo} />} />
        <Route path="/profile" element={<Profile userRepo={userRepo} />} />
        <Route path="/g/:shortId/*" element={<GroupRoutes userRepo={userRepo} />} />
        <Route path="/add-group/:secret" element={<AcceptGroupInvite userRepo={userRepo} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }
};
export default AuthRoutes;
